module.exports = __webpack_public_path__ + "img/Deal_Card.9494a59d.gif";